// @flow

import { type PaymentMethod } from '@tectonics/prs/payment-method';
import { type PaymentSpec } from './types';

export function getPaymentMethods(spec: PaymentSpec): ImmutableArray<PaymentMethod> {
  return spec.paymentMethods;
}
